const userRoles = {
	superAdmin			: 1,
	admin 				: 2,
	branchAdmin			: 3,
	billingStaff		: 4,
	executive			: 5,
	shippingStaff		: 6,
	shippingManager		: 7,
	salesManager		: 8,
	accounts			: 9,
	commissionManager	: 10,
}

export default userRoles
